import React from "react";
import XenieNewLogo from "../../Assets/XenieNewLogo.svg";
import Collection from "../../Assets/menuicons/Collection.svg";
import Coupon from "../../Assets/menuicons/Coupon.svg";
// import Customer from "../../Assets/menuicons/Customer.svg";
import Dashboard from "../../Assets/menuicons/Dashboard.svg";
import DropTrack from "../../Assets/menuicons/Droptrack.svg";
import Finance from "../../Assets/menuicons/Finance.svg";
import Inventory from "../../Assets/menuicons/Inventory.svg";
import Lens from "../../Assets/menuicons/Lens.svg";
import Order from "../../Assets/menuicons/Order.svg";
import Report from "../../Assets/menuicons/Report.svg";
// import Return from "../../Assets/menuicons/Return.svg";
// import "./Menubar.css";
import { Link, useLocation } from "react-router-dom";
import MenuItem from "./Components/MenuItem";
import StorefrontIcon from "../../Assets/menuicons/Storefront.png";
import { apiV1 } from "../../Auth/Interceptor";
import { setUser } from "../../Features/userSlice";
import { useDispatch, useSelector } from "react-redux";

export default function Menubar() {
    const location = useLocation();
    const dispatch = useDispatch();
    const user = useSelector((state) => state.user.user);
    const memoizedUser = React.useMemo(() => user || {}, [user]);
    const [roles, setRoles] = React.useState([]);

    // Define the menu items array
    const menuItems = [
        { path: "/", icon: Dashboard, label: "Dashboard" },
        { path: "/storefront", icon: StorefrontIcon, label: "Storefront" },
        { path: "/collections", icon: Collection, label: "Collections" },
        { path: "/lens-and-reviews", icon: Lens, label: "Lens and Reviews" },
        {
            path: "/droptrack-products",
            icon: DropTrack,
            label: "DropTrack Products",
        },
        { path: "/order-management", icon: Order, label: "Order Management" },
        {
            path: "/inventory-management",
            icon: Inventory,
            label: "Inventory Management",
        },
        { path: "/coupon-management", icon: Coupon, label: "Coupon Management" },
        {
            path: "/finance-management",
            icon: Finance,
            label: "Finance Management",
        },
        // { path: "/returnandrefund", icon: Return, label: "Return and Refund" },
        {
            path: "/report-and-analytics",
            icon: Report,
            label: "Report and Analytics",
        },
        // { path: "/customerinquiry", icon: Customer, label: "Customer Inquiry" },
    ];

    const roleBasedAccess = {
        Admin: menuItems.map((item) => item.label),
        "Store Manager": ["Storefront"],
        "Inventory Manager": [
            "Inventory Management",
            "Coupon Management",
            "Collections",
            "DropTrack Products",
            "Order Management",
        ],
        "Lens Manager": ["Lens and Reviews", "Report and Analytics"],
    };

    const userProfile = async () => {
        try {
            const response = await apiV1.get("sellerMembers/profile");
            if (response.status !== 200) {
                throw new Error("Failed to fetch user details");
            }
            return response.data.data;
        } catch (error) {}
    };

    React.useEffect(() => {
        async function getUserProfileData() {
            const data = await userProfile();
            dispatch(setUser(data));
        }
        getUserProfileData();
        // eslint-disable-next-line
    }, []);

    React.useEffect(() => {
        if (Object.keys(memoizedUser).length > 0) {
            setRoles(memoizedUser.role);
        }
    }, [memoizedUser]);

    const getMenuItemsForRoles = (roles) => {
        let allowedItems = new Set();

        roles.forEach((role) => {
            if (roleBasedAccess[role]) {
                roleBasedAccess[role].forEach((item) => allowedItems.add(item));
            }
        });

        return menuItems.filter((item) => allowedItems.has(item.label));
    };

    const filteredMenuItems = getMenuItemsForRoles(roles);

    return (
        <div className="flex flex-col bg-[#1F2937] gap-6 px-2 py-[10px] h-[100vh]">
            <div className="px-2 h-12 flex items-center">
                <Link to="/">
                    <img className="w-auto h-10" src={XenieNewLogo} alt="xenie-logo" />
                </Link>
            </div>

            <div className="flex flex-col gap-2">
                {filteredMenuItems.map((menuItem, index) => {
                    let isActive;
                    if (
                        menuItem.path.length === 1 &&
                        location.pathname.length > 1
                    ) {
                        isActive = false;
                    } else {
                        isActive = location.pathname.includes(menuItem.path);
                    }

                    return (
                        <MenuItem
                            key={index}
                            path={menuItem.path}
                            icon={menuItem.icon}
                            label={menuItem.label}
                            style={
                                isActive
                                    ? "bg-[#111827] rounded-md text-[#FFFFFF]"
                                    : ""
                            }
                        />
                    );
                })}
            </div>
        </div>
    );
}
